import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { formatDisplayDate } from "Helper";

// Gaya untuk dokumen PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    position: "relative",
    backgroundColor: "#ffffff",
  },
  // Kotak logo di pojok kanan atas
  logoContainer: {
    position: "absolute",
    top: 30,
    right: 30,
    width: 50,
    height: 50,
    // backgroundColor: "#1E1E1E",
    // justifyContent: "center",
    // alignItems: "center",
    // border: "2 solid #000",
  },
  logoText: {
    color: "#E3B23C",
    fontSize: 24,
    fontWeight: "bold",
  },
  // Garis kuning di atas
  topYellowLine: {
    position: "absolute",
    top: 50,
    left: 30,
    width: 60,
    height: 5,
    backgroundColor: "#E3B23C",
  },
  // Bagian bawah dengan latar gelap
  darkSection: {
    backgroundColor: "#2D3E50",
    height: "70%",
    width: "100%",
    position: "absolute",
    bottom: 0,
    padding: 40,
    justifyContent: "center",
  },
  title: {
    color: "#FFFFFF",
    fontSize: 50,
    fontWeight: "bold",
    textAlign: "left",
  },
  // Garis kuning di bawah teks utama
  bottomYellowLine: {
    marginTop: 20,
    width: 250,
    height: 4,
    backgroundColor: "#E3B23C",
  },
  // Informasi kontak di bawah
  // contactInfo: {
  //   color: "#FFFFFF",
  //   fontSize: 12,
  //   marginTop: 350,
  // },
  contactInfoContainer: {
    marginTop: 350,
  },
  contactRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  contactLabel: {
    color: "#FFFFFF",
    fontSize: 12,
    width: 60, // Pastikan semua label memiliki lebar tetap
    textAlign: "left",
  },
  colon: {
    color: "#FFFFFF",
    fontSize: 12,
    width: 10, // Pastikan lebar titik dua tetap agar sejajar
    textAlign: "center",
  },
  contactValue: {
    color: "#FFFFFF",
    fontSize: 12,
    flex: 1, // Biar teks value bisa panjang tanpa ganggu layout
  },
  logo: {
    width: 50,
    height: 80,
  },
});

const PdfSopCover = ({
  data = [],
  targets = [],
  today = new Date(),
  dataDetail,
}) => (
  <Page size="A4" style={styles.page}>
    {/* Kotak logo kanan atas */}
    <View style={styles.logoContainer}>
      <Image style={styles.logo} src="/logofr.png" />
    </View>

    {/* Garis kuning kiri atas */}
    <View style={styles.topYellowLine} />

    {/* Bagian bawah dengan warna gelap */}
    <View style={styles.darkSection}>
      <Text style={styles.title}>Report</Text>
      <Text style={styles.title}>Face Recognition (FR)</Text>
      <View style={styles.bottomYellowLine} />
      <View style={styles.contactInfoContainer}>
        <View style={styles.contactRow}>
          <Text style={styles.contactLabel}>Date</Text>
          <Text style={styles.colon}>:</Text>
          <Text style={styles.contactValue}>{formatDisplayDate(today)}</Text>
        </View>
        <View style={styles.contactRow}>
          <Text style={styles.contactLabel}>
            {data?.is_ip_camera === true ? "Kamera" : "Video"}
            {console.log(data, "data")}
          </Text>
          <Text style={styles.colon}>:</Text>
          <Text style={styles.contactValue}>
            {data?.is_ip_camera ? data?.name_camera : data?.video_file_name}
          </Text>
        </View>
        <View style={styles.contactRow}>
          <Text style={styles.contactLabel}>Target</Text>
          <Text style={styles.colon}>:</Text>
          <Text style={styles.contactValue}>
            {dataDetail?.length} People Detected
          </Text>
        </View>
      </View>
    </View>
  </Page>
);

export default PdfSopCover;
